import { SALARIES } from "./trainingData";

export default function SalarySection() {
  return (
    <section
      id="careers"
      className="border-t border-[#18181b] bg-[#050505] px-4 py-8 sm:p-10"
    >
      <div className="max-w-[1200px] mx-auto px-0 sm:px-6 py-12 sm:py-22">
        <div className="max-w-[720px] mb-11">
          <div
            className="font-mono text-[12px] text-[#71717a] mb-[18px]"
            style={{ letterSpacing: "0.18em" }}
          >
            06 — WHERE IT TAKES YOU
          </div>
          <h2
            className="font-bold text-white mb-[18px]"
            style={{
              fontSize: "clamp(30px, 3.7vw, 46px)",
              lineHeight: 1.06,
              letterSpacing: "-0.03em",
            }}
          >
            Roles you can apply for, level by level
          </h2>
          <p className="text-[16px] sm:text-[18px] leading-[1.65] text-[#a1a1aa]">
            You don&apos;t have to finish all ten to start earning. Most
            students take their first security job after Level 6.
          </p>
        </div>

        {/* Desktop table view */}
        <div className="hidden lg:block border border-[#27272a] rounded-xl overflow-hidden">
          <div
            className="grid grid-cols-[1.4fr_0.8fr_1fr_1fr] gap-6 py-4 px-[26px] bg-[#0f0f11] font-mono text-[11px] text-[#71717a]"
            style={{ letterSpacing: "0.12em" }}
          >
            <div>ROLE</div>
            <div>UNLOCKED AT</div>
            <div>ENTRY RANGE</div>
            <div>EXPERIENCED RANGE</div>
          </div>
          {SALARIES.map((s, i) => (
            <div
              key={i}
              className="grid grid-cols-[1.4fr_0.8fr_1fr_1fr] gap-6 py-5 px-[26px] border-t border-[#18181b] items-center"
            >
              <div className="text-[16px] font-semibold">{s.role}</div>
              <div className="font-mono text-[13px] text-[#a3e635]">
                {s.unlock}
              </div>
              <div className="font-mono text-[14px] text-[#d4d4d8]">
                {s.entry}
              </div>
              <div className="font-mono text-[14px] text-[#d4d4d8]">
                {s.senior}
              </div>
            </div>
          ))}
        </div>

        {/* Mobile stacked card view */}
        <div className="md:hidden border border-[#27272a] rounded-xl overflow-hidden">
          {SALARIES.map((s, i) => (
            <div
              key={i}
              className={`p-4 ${i > 0 ? "border-t border-[#18181b]" : "bg-[#0f0f11]"}`}
            >
              <div className="text-[15px] font-semibold mb-2">{s.role}</div>
              <div className="font-mono text-[12px] text-[#a3e635] mb-2">
                Unlocked at: {s.unlock}
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <div className="font-mono text-[10px] text-[#71717a] mb-0.5" style={{ letterSpacing: "0.1em" }}>
                    ENTRY
                  </div>
                  <div className="font-mono text-[13px] text-[#d4d4d8]">
                    {s.entry}
                  </div>
                </div>
                <div>
                  <div className="font-mono text-[10px] text-[#71717a] mb-0.5" style={{ letterSpacing: "0.1em" }}>
                    EXPERIENCED
                  </div>
                  <div className="font-mono text-[13px] text-[#d4d4d8]">
                    {s.senior}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="font-mono text-[11px] text-[#52525b] mt-3.5 leading-[1.7]">
          INDICATIVE ANNUAL RANGES IN USD, BASE PAY. ACTUAL PAY VARIES
          SHARPLY BY MARKET — NORTH AMERICA AND THE GCC SIT AT THE TOP OF
          EACH BAND, SOUTH AND SOUTHEAST ASIA AT THE START OF IT.
        </div>
      </div>
    </section>
  );
}
